// extracted by mini-css-extract-plugin
export default {"formWebLp":"WebFormLp_formWebLp__y6GGj","formWebLp__divBox":"WebFormLp_formWebLp__divBox__nitow"};